import { useMutation } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/react-query';

export interface PortalSessionResponse {
  url: string;
}

export const createCustomerPortalSession =
  (): Promise<PortalSessionResponse> => {
    return api.post('/billing/portal', undefined, { withCredentials: true });
  };

type UseCustomerPortalSessionOptions = {
  mutationConfig?: MutationConfig<typeof createCustomerPortalSession>;
};

export const useCustomerPortalSession = ({
  mutationConfig,
}: UseCustomerPortalSessionOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: createCustomerPortalSession,
    onSuccess: (data, ...args) => {
      onSuccess?.(data, ...args);
    },
    ...restConfig,
  });
};
